import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Route, Redirect, NavLink } from 'react-router-dom';
import { styles, TabContainer, Tab, LoadingSpinner } from 'yankees-react-utils';
import { useCachedOktaQuery, Player } from '../../../data';

const StyledTabContainerWrapper = styled.div`
    > div {
        position: absolute;
        top: 17px;
        right: 10px;
    }

    @media (max-width: 1112px) {
        > div {
            right: 5px;
            top: 18px;

            > div > a {
                font-size: 12px;
            }
        }
    }
    .active-tab {
        font-weight: initial;
        color: inherit !important;
        background: ${styles.theme.background.concrete} !important;
        border-bottom-color: ${styles.theme.background.concrete};
    }
`;

const BasePlayerReport = ({ pathname, path, url, tabs, playerId, playerTeamStartingPitchers }) => {
    const { data: player, isFetching, isLoading } = useCachedOktaQuery(
        ['player', playerId],
        (t) => Player.get(t, { playerId }),
    );
    const reportProps = { playerId, isLoading: (isFetching || isLoading), player, playerTeamStartingPitchers };
    if (isFetching || isLoading) return <LoadingSpinner />;
    return (
        <>
            <StyledTabContainerWrapper>
                <TabContainer>
                    {tabs.map(({ title, route }) => (
                        <Tab key={route} as={NavLink} to={`${url}/${route}`}>
                            {title}
                        </Tab>
                    ))}
                </TabContainer>
            </StyledTabContainerWrapper>
            {pathname === url && <Redirect to={`${url}/${tabs[0].route}`} />}
            {tabs.map(({ route, component: render }) => (
                <Route key={route} path={`${path}/${route}`} render={(routerProps) => render({ ...routerProps, ...reportProps })} />
            ))}
        </>
    );
};

BasePlayerReport.propTypes = {
    pathname: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    playerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    tabs: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        route: PropTypes.string.isRequired,
        component: PropTypes.func.isRequired,
    })),
    playerTeamStartingPitchers: PropTypes.arrayOf(PropTypes.shape({})),
};
BasePlayerReport.defaultProps = {
    tabs: [],
    playerTeamStartingPitchers: undefined,
};

export default BasePlayerReport;
